<template>
  <div class="page">
    <!-- Content Section and Navigation Together -->
    <div class="content-wrapper">
      <!-- Content Section -->
      <div class="content-section">
        <div v-for="(item, index) in content.Items" :key="index" class="content-item">
          <div class="card">  
            <div class="card-body">
              <h1 class="title">{{ item.title }}</h1>
              <div v-html="formattedDescriptionNo(item.description_no_1)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_1)" class="description"></div>
 
              <div v-html="formattedDescriptionNo(item.description_no_2)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_2)" class="description"></div>
 
              <div v-html="formattedDescriptionNo(item.description_no_3)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_3)" class="description"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Section (moved to the right) -->
      <div class="contact-container">
        <h2>Contact Information</h2>
        <div class="contact-info">
          <i class="fas fa-phone"></i>
          <p>Phone: 暂无(E-mail Only)</p>
        </div>
        <div class="contact-info">
          <i class="fas fa-envelope"></i>
          <p>Email: dankao.chen@nxtech.pub</p>
        </div>
        <!-- Add more contact info as needed -->
      </div>
    </div>
  </div>
</template>

<style src="@/assets/css/cases.css" scoped></style>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      cn: {
        Items: [
          {
            id: 1,
            image: require("@/assets/img/Logo.jpg"),
            title: "基于虚幻引擎的陶粒工厂生产工艺流程演示片",
            description_no_1:`
              1. <b class='custom-bold'>项目背景与需求分析</b>
            `,
            description_1:`
              近年来，随着环保意识的日益增强和新型建筑材料的不断涌现，陶粒作为一种轻质且具备高强度的建筑材料，在建筑、道路、园林等多个领域展现出了广泛的应用潜力。同时，随着科技的持续进步，陶粒工厂正逐步迈向智能化、绿色化、高效化的发展道路，以满足市场对于高品质、高附加值产品的迫切需求。在陶粒工厂的持续发展进程中，如何以高效且精准的方式展示工厂的完整工艺流程、独特产品特性以及显著的技术优势，已成为提升品牌形象、扩大市场份额的关键举措。因此，定制一款专门针对陶粒工厂的演示片，显得尤为重要。

              针对陶粒工厂的鲜明特色，我们经过细致剖析，深入洞察了客户的实际需求。客户期望通过一部精心制作的演示片，全方位、多角度地呈现陶粒工厂的生产流程、产品亮点以及技术底蕴。同时，客户亦希望该演示片能够充分展现工厂在绿色环保和创新发展方面的理念，从而有效提升品牌形象，增强市场竞争力。

              为切实满足客户的期望，我们决定运用基于虚幻引擎的先进CG动画制作技术，为陶粒工厂量身打造一部高品质的CG动画演示片。借助虚幻引擎卓越的渲染能力和交互设计功能，我们将确保演示片能够生动展现工艺流程的每一个环节，精准凸显产品的独特优势，并充分彰显工厂在技术领域的雄厚实力。

              虚幻引擎（Unreal Engine）是业界前沿的游戏引擎平台，在游戏开发领域展现了令人赞叹的图形性能。近年来，虚幻引擎在工业领域同样展露了卓越的性能。借助这一技术，我们能够实现非标工业设备的精准建模和高效渲染，进而打造出更为逼真且生动的视觉表现。

              在陶粒工厂的演示片制作过程中，我们充分发挥虚幻引擎的建模与渲染能力，对工厂内核心设备进行细致入微的建模与渲染处理。通过直观展示设备的内部结构、工作原理以及运行状态，我们将助力客户更全面地洞悉陶粒工厂的生产流程与技术底蕴。
            `,
          description_no_2:`
            2. <b class='custom-bold'>项目策划与设计方案</b>
          `,
          description_2:`
            在确定了客户需求和技术路线后，我们进一步明确了演示片的主题和风格，将“绿色、创新、高效”作为核心主题，通过展示陶粒工厂的环保理念、技术创新和生产效率，凸显其品牌形象和竞争优势。在风格方面，我们选择了现代简约风格，以简洁明了的画面和流畅自然的过渡来展现陶粒工厂的特点和优势。为了全面展示陶粒工厂的生产流程，我们详细梳理并筛选了最具代表性和观赏性的工艺流程环节，通过虚拟环境的构建和动态展示技术，将这些环节以生动逼真的形式呈现出来。

            在梳理工艺流程的过程中，我们特别关注了环保和节能方面的措施，以体现陶粒工厂的绿色环保理念，并通过演示片展示工厂在废气排放等方面的先进技术和有效成果。此外，我们还注重场景设计和虚拟环境的构建，根据工艺流程的特点和客户需求，设计了一系列符合陶粒工厂实际情况的场景，并利用虚幻引擎的建模和渲染技术构建出逼真的虚拟环境，以提升观众的沉浸感和代入感。

            同时，我们针对陶粒工厂中的非标工业设备，采用了定制化的建模策略，根据设备的实际结构和特点进行精细化建模和渲染，以呈现出设备的真实形态和运行状态。在整个制作过程中，我们注重细节处理和材质表现，以确保演示片能够真实、生动地展现陶粒工厂的各个方面。
          `,
          description_no_3:`
            3. <b class='custom-bold'>项目实施效果</b>
          `,
          description_3:`
            本次陶粒工厂演示片制作案例的成功实施，不仅满足了客户的实际需求，也为公司的业务发展带来了积极的推动作用。通过演示片的展示和推广，陶粒工厂的品牌形象和市场竞争力得到了有效提升，进一步拓展了客户公司的业务范围和市场份额。
          `,
          },
          // Add more items as needed
        ],
      },
      en: {
        Items: [
          {
            id: 2,
            image: require("@/assets/img/Logo.jpg"),
            title: "Unreal Engine-based Ceramsite factory production-process demo film",
            description_no_1:`
              1. <b class='custom-bold'>Project Background and Requirements Analysis</b>
            `,
            description_1:`
              In recent years, with the growing awareness of environmental protection and the emergence of new building materials, Ceramsite, as a lightweight and high-strength building materials, in construction, roads, gardens and other areas show a wide range of application potential. At the same time, with the continuous progress of science and technology, Ceramsite factory is gradually moving towards the development of intelligent, green and efficient road, in order to meet the market for high-quality, high value-added products for the urgent needs. In the continuous development of Ceramsite factories, how to efficiently and accurately show the complete process, unique product characteristics and significant technical advantages of the factory has become a key measure to enhance the brand image and expand market share. Therefore, it is especially important to customise a presentation film specifically for Ceramsite factories.

              In view of the distinctive features of the Ceramsite factory, we have analysed in detail and gained a deep insight into the actual needs of the client. The client expects that through a well-made film, the production process, product highlights and technical heritage of the Ceramsite factory can be presented in an all-round and multi-angle way. At the same time, the client also hoped that the film could fully demonstrate the factory's concept of green environmental protection and innovative development, thus effectively enhancing the brand image and market competitiveness.

              In order to meet the client's expectations, we decided to use the advanced CG animation technology based on Unreal Engine to create a high-quality CG animation film for the Ceramsite factory. With the excellent rendering ability and interactive design function of Unreal Engine, we will ensure that the demo film can vividly show every link of the process, accurately highlight the unique advantages of the product, and fully demonstrate the factory's strong strength in the field of technology.

              The Unreal Engine is the industry's leading game engine platform and has demonstrated impressive graphics performance in game development. In recent years, the Unreal Engine has demonstrated the same performance in the industrial sector. With this technology, we are able to accurately model and efficiently render non-standard industrial equipment to create more realistic and vivid visual representations.

              During the production of the Ceramsite factory demo, we gave full play to the modelling and rendering capabilities of the Unreal Engine, and carried out detailed modelling and rendering of the core equipment in the factory. By visually displaying the internal structure, working principle and operation status of the equipment, we will help our clients to have a more comprehensive understanding of the Ceramsite factory's production process and technical heritage.
            `,
            description_no_2:`
              2. <b class='custom-bold'>Project Planning & Design Solutions</b>
            `,
            description_2:`
              After identifying the customer's needs and technology lines, we further specify the theme and style of the demo film, taking ‘Green, Innovative, Efficient’ as the core theme, highlighting the brand image and competitive advantages of the Ceramsite factory by demonstrating its environmental protection concepts, technological innovations and production efficiencies. In terms of style, we chose a modern minimalist style to show the features and advantages of Ceramsite factory with simple and clear picture and smooth and natural transition. In order to comprehensively show the production process of Ceramsite factory, we combed and screened the most representative and ornamental process links in detail, and presented these links in a vivid and realistic form through the construction of virtual environment and dynamic display technology.

              In the process of sorting out the process flow, we pay special attention to the environmental protection and energy saving measures to reflect the Ceramsite factory's green environmental protection concept, and through the demonstration film to show the factory's advanced technology and effective results in the exhaust gas emission and other aspects. In addition, we also pay attention to scene design and construction of virtual environment, according to the characteristics of the process and customer needs, we designed a series of scenes in line with the actual situation of the Ceramsite factory, and used the modelling and rendering technology of the Unreal Engine to build a realistic virtual environment to enhance the audience's sense of immersion and sense of immersion.

              At the same time, we adopted a customised modelling strategy for the non-standard industrial equipment in the Ceramsite factory, and carried out fine modelling and rendering according to the actual structure and characteristics of the equipment, in order to present the real form and operating state of the equipment. Throughout the production process, we paid attention to detail processing and material performance to ensure that the demo film can truly and vividly show all aspects of the Ceramsite factory.
            `,
            description_no_3:`3. <b class='custom-bold'>Achievements of project implementation</b>`,
            description_3:`
              The successful implementation of this Ceramsite factory demonstration film production case, not only to satisfy the actual needs of the customer, but also bring positive impetus to the company's business development. Through the demonstration and promotion of the demo film, Ceramsite factory's brand image and market competitiveness has been effectively enhanced, further expanding the customer company's business scope and market share.
            `,
          },
          // Add more items as needed
        ],
      },
    };
  },
  methods: {
    formattedDescription(description) {
      // Apply additional formatting if needed
      return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
    formattedDescriptionNo(description_no) {
      // Apply additional formatting if needed
      return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
  },
  mixins: [],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>
